import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/logo.svg'


const _hoisted_1 = { class: "top-bar d-flex flex-row justify-content-between align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column align-items-center" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "",
      src: _imports_0
    })
  ])
], -1)
const _hoisted_4 = { class: "d-flex flex-column align-items-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_ctx.props.showLogOut)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-outline-light sign-off-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doLogout()))
          }, _toDisplayString(_ctx.$t('general.logout')), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}